import { isCancelRequest } from '../../../configs/axios';
import { fetchPageDataRequest } from '../api';
import { PAGE_ASSETS, DEFAULT_APPS_FILTERS } from '../configs/constants';
import {
  FETCH_PAGE_DATA_REQUEST,
  FETCH_PAGE_DATA_SUCCESS,
  FETCH_PAGE_DATA_FAILURE,
} from './actionTypes';

const ALL_ASSETS = Object.values(PAGE_ASSETS);

const normalizePayload = (data) => ({
  ...(data.general && { general: data.general }),
  ...(data.totals && { totals: data.totals }),
  ...(data.apps && { apps: data.apps }),
  ...(data.monetization && { monetization: data.monetization }),
  ...(data.time_series && { timeSeries: data.time_series }),
  ...(data.sdks && { sdks: data.sdks }),
  ...((data.company || data.key_contacts) && {
    companyInfo: {
      company: data.company || null,
      keyContacts: data.key_contacts || [],
    },
  }),
});

export const fetchPageData =
  (assets = ALL_ASSETS) =>
  (dispatch, getState) => {
    const { filters, apps } = getState();

    dispatch({ type: FETCH_PAGE_DATA_REQUEST, payload: { assets } });

    const appsParams = assets.includes(PAGE_ASSETS.apps)
      ? {
          metric: apps.filters.metric,
          order: apps.filters.order,
          offset: 0,
          limit: apps.filters.offset + DEFAULT_APPS_FILTERS.limit,
        }
      : {};

    return fetchPageDataRequest({ ...filters, ...appsParams, assets })
      .then((data) => {
        dispatch({
          type: FETCH_PAGE_DATA_SUCCESS,
          payload: { assets, data: normalizePayload(data) },
        });
      })
      .catch((error) => {
        if (isCancelRequest(error)) return;

        dispatch({ type: FETCH_PAGE_DATA_FAILURE, payload: { assets, error: error.message } });
      });
  };
